import axios from "axios";

export const getFile = async (url) => {
  if (!url) return false;

  try {
    const response = await axios.get(url, { responseType: "blob" });
    // console.log(
    //   "URL.createObjectURL(response.data);",
    //   URL.createObjectURL(response.data)
    // );
    return URL.createObjectURL(response.data);
  } catch (error) {
    // console.error("Error fetching file:", error);
    return false;
  }
};
